/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { GetAllSitesResponse } from '../models/GetAllSitesResponse';
import type { GetInviteCrcUserSiteInfoResponse } from '../models/GetInviteCrcUserSiteInfoResponse';
import type { GetPreRegisteredSitesResponse } from '../models/GetPreRegisteredSitesResponse';
import type { GetSiteContactsResponse } from '../models/GetSiteContactsResponse';
import type { GetSiteOverviewResponse } from '../models/GetSiteOverviewResponse';
import type { GetSitePatientsResponse } from '../models/GetSitePatientsResponse';
import type { GetSitesResponse } from '../models/GetSitesResponse';
import type { SendSiteRegistrationReminderResponse } from '../models/SendSiteRegistrationReminderResponse';
import type { SetPrimaryCrcRequest } from '../models/SetPrimaryCrcRequest';
import type { UpdateSiteInformationRequest } from '../models/UpdateSiteInformationRequest';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class SiteControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetPreRegisteredSitesResponse
     * @throws ApiError
     */
    public siteControllerv2GetPreRegisteredSites(): Observable<Array<GetPreRegisteredSitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/preregistered',
        });
    }
    /**
     * @param siteId
     * @returns SendSiteRegistrationReminderResponse
     * @throws ApiError
     */
    public siteControllerv2SendSiteRegistrationReminder(
        siteId: number,
    ): Observable<SendSiteRegistrationReminderResponse> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/sites/{siteId}/reminder',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param statusId
     * @returns GetPreRegisteredSitesResponse
     * @throws ApiError
     */
    public siteControllerv2GetSitesByStatusCount(
        statusId: number,
    ): Observable<Array<GetPreRegisteredSitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/status/{statusId}/count',
            path: {
                'statusId': statusId,
            },
        });
    }
    /**
     * @param statusIds
     * @returns GetAllSitesResponse
     * @throws ApiError
     */
    public siteControllerv2GetAllSites(
        statusIds?: Array<number> | null,
    ): Observable<Array<GetAllSitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/list',
            query: {
                'statusIds': statusIds,
            },
        });
    }
    /**
     * @returns GetSitesResponse
     * @throws ApiError
     */
    public siteControllerv2GetSites(): Observable<Array<GetSitesResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites',
        });
    }
    /**
     * @param siteId
     * @returns GetSiteOverviewResponse
     * @throws ApiError
     */
    public siteControllerv2GetSiteOverview(
        siteId: number,
    ): Observable<GetSiteOverviewResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/overview/{siteId}',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param siteId
     * @returns GetSiteContactsResponse
     * @throws ApiError
     */
    public siteControllerv2GetSiteContacts(
        siteId: number,
    ): Observable<Array<GetSiteContactsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/{siteId}/contacts',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public siteControllerv2SetPrimaryCrc(
        requestBody: SetPrimaryCrcRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/sites/set-primary-crc',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @returns GetSitePatientsResponse
     * @throws ApiError
     */
    public siteControllerv2GetSitePatients(
        siteId: number,
    ): Observable<Array<GetSitePatientsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/{siteId}/patients',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param requestBody
     * @returns binary
     * @throws ApiError
     */
    public siteControllerv2UpdateSiteInformation(
        requestBody: UpdateSiteInformationRequest,
    ): Observable<Blob> {
        return __request(OpenAPI, this.http, {
            method: 'POST',
            url: '/api/v2/sites/update/info',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param siteId
     * @returns GetInviteCrcUserSiteInfoResponse
     * @throws ApiError
     */
    public siteControllerv2GetInviteCrcUserSiteInfo(
        siteId: number,
    ): Observable<GetInviteCrcUserSiteInfoResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/{siteId}/invite-crc-user/site-info',
            path: {
                'siteId': siteId,
            },
        });
    }
    /**
     * @param countryName
     * @returns boolean
     * @throws ApiError
     */
    public siteControllerv2IsCountrySupportedByPayQuicker(
        countryName?: string | null,
    ): Observable<boolean> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/sites/payquicker/country-supported',
            query: {
                'countryName': countryName,
            },
        });
    }
}
